import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_7688_19756)" }, [
      _createElementVNode("path", {
        d: "M15.6485 0.513672H11.9409V15.4992C11.9409 17.2847 10.5149 18.7514 8.74027 18.7514C6.96567 18.7514 5.53966 17.2847 5.53966 15.4992C5.53966 13.7456 6.93399 12.3107 8.64522 12.247V8.4847C4.87419 8.54844 1.83203 11.6412 1.83203 15.4992C1.83203 19.3891 4.93757 22.5137 8.77198 22.5137C12.6063 22.5137 15.7119 19.3572 15.7119 15.4992V7.8151C17.1062 8.83542 18.8174 9.44121 20.6237 9.47311V5.71077C17.8351 5.61512 15.6485 3.31947 15.6485 0.513672Z",
        fill: "white"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_7688_19756" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(0 0.513672)"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }